<section class="relative flex flex-col items-center gap-6">
  <div
    class="absolute h-full w-full bg-[radial-gradient(#d1d5db_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_85%,transparent_100%)]"
  ></div>
  <div class="z-10">
    <tui-badge appearance="neutral" iconStart="@tui.zap" size="xl">
      Live Updates
    </tui-badge>
  </div>
  <div class="z-10 flex flex-col items-center gap-14">
    <h1 class="text-center text-4xl font-bold leading-relaxed md:text-5xl">
      @defer {
        Ship fixes and features<br /><span
          [roughNotation]="{
            animate: true,
            animationDelay: 500,
            strokeWidth: 3,
            iterations: 4,
            type: 'underline',
            color: 'var(--tui-background-accent-2)',
            padding: 2,
          }"
          >in real time</span
        >
      } @placeholder {
        Ship fixes and features<br />in real time
      }
    </h1>
    <p class="w-full text-balance text-center text-xl leading-snug md:w-3/4">
      <span class="hidden md:block"
        >Go from code to user devices in under 60 seconds. Skip app store
        reviews and deliver updates the moment you're ready. No waiting, no
        delays, no stress.</span
      >
      <span class="md:hidden"
        >Deploy updates to user devices in under 60 seconds. Skip app store
        reviews entirely.</span
      >
    </p>
    <div class="flex flex-col items-center gap-3">
      <div class="flex space-x-4">
        <a
          iconEnd="@tui.arrow-right"
          size="l"
          tuiButton
          type="button"
          [href]="consoleBaseUrl"
          target="_blank"
          data-umami-event="landing-hero-start-free-button"
        >
          Start for free
        </a>
        <a
          appearance="secondary"
          size="l"
          tuiButton
          type="button"
          [href]="bookingUrl"
          target="_blank"
          data-umami-event="landing-hero-booking-demo-button"
          id="of-get-a-demo-body"
        >
          Book a demo
        </a>
      </div>
      @if (statistics.data(); as data) {
        <p class="flex items-center gap-1.5 text-sm text-gray-600">
          <span>⚡</span>
          <span
            ><b>{{ data.lastMonthAppBundleDownloads | number }} Live Updates</b>
            delivered last month</span
          >
        </p>
      }
    </div>
  </div>
  <!-- Idea: Phone with incoming messages regarding a critical bug in the app -->
  <!-- https://taiga-ui.dev/components/message -->
  <!-- Easter Egg: With every page reload another story -->
  <!-- Last message is always a link to Capawesome Cloud (Get Started CTA) -->
  <!-- Another Idea: Animated Terminal using Capawesome CLI to publish a live update -->
  <!-- Another Idea: Globe that services live updates -->
</section>
